<template>
  <b-modal id="bv-modal-download-album-choice"
           size="md"
           centered
           hide-header>
    <div class="text-center">
      <Icon name="grDownload" :width="36" class="mb-3"/>
      <h1 class="modal-title mb-2">{{ $t('modal_download_album_choice.title') }}</h1>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="w-100">
        <b-button variant="primary" block @click="downloadEmail" :disabled="loading" class="mb-2">
          <b-spinner small v-if="loading" class="mr-1"></b-spinner>
          <Icon v-else name="send" :width="18" class="mr-1" vertical-align="sub"/>
          {{ $t('modal_download_album_choice.action_email') }}
        </b-button>
        <b-button variant="link" block @click="cancel()" class="text-secondary">
          {{ $t('modal_download_album_choice.action_cancel') }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import EventService from "@/services/Event";

export default {
  name: "ModalDownloadAlbumChoice",
  

  props: {
    checkin: {
      type: Object,
      default: null,
    },
    galleryId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      loading: false,
    }
  },

  computed: {
    effectiveCheckin() {
      return this.checkin || this.$store.getters['checkinDetail/checkin']
    },
  },

  methods: {
    downloadEmail() {
      this.loading = true
      EventService.downloadAlbum(this.effectiveCheckin.id, this.galleryId)
          .then(() => {
            this.$bvToast.toast(
                this.$t('toast_download_album.text'),
                {
                  title: this.$t('toast_download_album.title'),
                  headerClass: 'd-block pt-2',
                  noCloseButton: false,
                  autoHideDelay: 5000
                })
            this.$bvModal.hide('bv-modal-download-album-choice')
          })
          .catch(error => {
            if (error.response && error.response.status === 400 &&
                (error.response.data.code === 'bulk_download_not_available' || error.response.data.code === 'bulk_download_missing_hd')) {
              this.$bvToast.toast(
                  this.$t('toast_download_album.error'),
                  {variant: 'warning', autoHideDelay: 8000, html: true})
            }
            this.$bvModal.hide('bv-modal-download-album-choice')
          }).finally(() => this.loading = false)
    },
  },
}
</script>
